var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightPolygonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 6",
    d: "M12 6.5L0.75 12.9952L0.75 0.00480938L12 6.5Z",
    fill: "#CB3050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPolygonArrow);
export default __webpack_public_path__ + "static/media/right_polygon_arrow.92eedf7526e6064753ae601ecb0e473b.svg";
export { ForwardRef as ReactComponent };